import { get, post, put, del } from "./api_helper"
import { apiUrl } from "../common/config/apiUrl"

const CHAT_API = `${apiUrl}/backend/chat`

// Conversations
export const getConversations = (params) =>
  get(`${CHAT_API}/conversations`, { params })

export const getConversationById = (id) =>
  get(`${CHAT_API}/conversations/${id}`)

export const getConversationMessages = (conversationId, params) =>
  get(`${CHAT_API}/conversations/${conversationId}/messages`, { params })

export const getQueuedConversations = (siteId) =>
  get(`${CHAT_API}/conversations/queue`, { params: { site_id: siteId } })

export const sendMessage = (conversationId, message, senderType = "agent") =>
  post(`${CHAT_API}/conversations/${conversationId}/message`, {
    message,
    sender_type: senderType
  })

export const assignConversation = (conversationId, agentUserId) =>
  put(`${CHAT_API}/conversations/${conversationId}/assign`, {
    agent_user_id: agentUserId
  })

export const transferConversation = (conversationId, toAgentUserId) =>
  put(`${CHAT_API}/conversations/${conversationId}/transfer`, {
    to_agent_user_id: toAgentUserId
  })

export const closeConversation = (conversationId) =>
  put(`${CHAT_API}/conversations/${conversationId}/close`, {})

export const addConversationTags = (conversationId, tags) =>
  post(`${CHAT_API}/conversations/${conversationId}/tags`, { tags })

export const getUnreadCount = (conversationId, senderType) =>
  get(`${CHAT_API}/conversations/${conversationId}/unread`, {
    params: { sender_type: senderType }
  })

export const updateCustomerDetails = (conversationId, details) =>
  put(`${CHAT_API}/conversations/${conversationId}/customer`, details)

// Agents
export const getAgents = (params) =>
  get(`${CHAT_API}/agents`, { params })

export const getOnlineAgents = (siteId) =>
  get(`${CHAT_API}/agents/online`, { params: { site_id: siteId } })

export const getAgentById = (userId) =>
  get(`${CHAT_API}/agents/${userId}`)

export const getAgentStats = (userId) =>
  get(`${CHAT_API}/agents/${userId}/stats`)

export const updateAgentStatus = (userId, status) =>
  put(`${CHAT_API}/agents/${userId}/status`, { status })

export const createAgent = (data) =>
  post(`${CHAT_API}/agents`, data)

export const updateAgent = (userId, data) =>
  put(`${CHAT_API}/agents/${userId}`, data)

export const deleteAgent = (userId) =>
  del(`${CHAT_API}/agents/${userId}`)

// Widget/Upload
export const uploadChatFile = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return post(`${CHAT_API}/widget/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// Tickets
export const convertToTicket = (conversationId, data) =>
  post(`${CHAT_API}/tickets/conversations/${conversationId}/convert`, data)

export const getTickets = (params) =>
  get(`${CHAT_API}/tickets`, { params })

export const getTicketById = (id) =>
  get(`${CHAT_API}/tickets/${id}`)

export const updateTicketStatus = (id, status) =>
  put(`${CHAT_API}/tickets/${id}/status`, { status })

export const assignTicket = (id, agentUserId) =>
  put(`${CHAT_API}/tickets/${id}/assign`, { agent_user_id: agentUserId })

export const updateTicketPriority = (id, priority) =>
  put(`${CHAT_API}/tickets/${id}/priority`, { priority })

export const addTicketComment = (id, comment, isInternal = false, attachments = []) =>
  post(`${CHAT_API}/tickets/${id}/comments`, {
    comment,
    is_internal: isInternal,
    attachments
  })

export const getTicketComments = (id, includeInternal = true) =>
  get(`${CHAT_API}/tickets/${id}/comments`, {
    params: { include_internal: includeInternal }
  })

export const getOverdueTickets = (siteId) =>
  get(`${CHAT_API}/tickets/overdue`, { params: { site_id: siteId } })

export const addTicketTags = (id, tags) =>
  post(`${CHAT_API}/tickets/${id}/tags`, { tags })

// Canned Responses
export const getCannedResponses = (params) =>
  get(`${CHAT_API}/canned-responses`, { params })

export const getCannedResponseById = (id) =>
  get(`${CHAT_API}/canned-responses/${id}`)

export const createCannedResponse = (data) =>
  post(`${CHAT_API}/canned-responses`, data)

export const updateCannedResponse = (id, data) =>
  put(`${CHAT_API}/canned-responses/${id}`, data)

export const deleteCannedResponse = (id) =>
  del(`${CHAT_API}/canned-responses/${id}`)

export const getCannedResponseByShortcut = (shortcut, siteId) =>
  get(`${CHAT_API}/canned-responses/shortcut/${shortcut}`, {
    params: { site_id: siteId }
  })

export const getCannedResponseCategories = (siteId) =>
  get(`${CHAT_API}/canned-responses/categories`, {
    params: { site_id: siteId }
  })

export const getMostUsedCannedResponses = (siteId, limit = 10) =>
  get(`${CHAT_API}/canned-responses/most-used`, {
    params: { site_id: siteId, limit }
  })

// Analytics
export const getAnalyticsDashboard = (params) =>
  get(`${CHAT_API}/analytics/dashboard`, { params })

export const getAgentPerformance = (agentId, params) =>
  get(`${CHAT_API}/analytics/agents/${agentId}/performance`, { params })

export const getConversationTrends = (params) =>
  get(`${CHAT_API}/analytics/trends`, { params })

export const getSatisfactionMetrics = (params) =>
  get(`${CHAT_API}/analytics/satisfaction`, { params })
